import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/drob/kakovostniRazred";

export const fetchQualityGrade = createAsyncThunk(
  "quality-grade/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchQualityGradePage = createAsyncThunk(
  "quality-grade/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchQualityGradeBySifra = createAsyncThunk(
  "quality-grade/byCode",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const qualityGradeSlice = createSlice({
  name: "qualityGrade",
  initialState: {
    page: null,
    list: [],
    byId: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQualityGrade.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(fetchQualityGrade.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchQualityGrade.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQualityGradePage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchQualityGradePage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchQualityGradePage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQualityGradeBySifra.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQualityGradeBySifra.fulfilled, (state, action) => {
        state.isLoading = false;
        const item = action.payload;
        if (item?.sifra) {
          state.byId[item.sifra] = item;
          state.details = item.sifra;
        }
      })
      .addCase(fetchQualityGradeBySifra.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default qualityGradeSlice.reducer;
